@use '@dixa/lib-shared-tokens/scss' as *;

.contentBox {
  margin-left: var(--dixa-size-spacer-500);
  padding: var(--dixa-size-spacer-200);
  background: var(--dixa-color-neutral-100);
  border: 1px solid var(--dixa-color-neutral-200);
  border-radius: var(--dixa-size-border-radius-100);
}
